var React = require('react');

function IconMarine (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M22.654 18.37c-1.07 0-1.94-.89-1.94-1.987s.87-1.986 1.94-1.986c1.072 0 1.94.889 1.94 1.986 0 1.098-.868 1.987-1.94 1.987zm-8.476 0c-1.072 0-1.94-.89-1.94-1.987s.868-1.986 1.94-1.986c1.071 0 1.94.889 1.94 1.986 0 1.098-.869 1.987-1.94 1.987zm46.943.904l-3.137-.338-3.5-6.63C31.98 10.189 8.709 9.954.538 9.943c1.64 4.898 7.765 12.142 11.928 12.702 7.133.958 20.147.81 20.147.81l28.399-.012.11-4.168zM21.006 2.735l1.98-.154-.953 4.062a261.042 261.042 0 0 0-5.17-.455l4.143-3.453zm3.57-.277l6.017-.467-.832 5.497a412.746 412.746 0 0 0-6.16-.682l.975-4.348zm26.746 8.73L39.817 8.792s-6.537-.65-7.452-.779L33.446 0 20.33 1.101l-5.294 4.952C6.949 5.497.129 5.585.12 7.58c-.002.455.073.964.214 1.51 11.309-.265 39.606 1.02 50.987 2.097z"}));
}

IconMarine.defaultProps = {"viewBox":"0 0 62 24"};

module.exports = IconMarine;

IconMarine.default = IconMarine;
